<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <AdminLoginForm />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import AdminLoginForm from '@/components/admin/AdminLoginForm.vue';

export default {
    name: 'AdminLogin',
    components: {
        Header,
        Footer,
        AdminLoginForm,
    },
}
</script>
